import {
  collection,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
  updateDoc
} from 'firebase/firestore'
import { firestore } from './firebaseClient'

const USERS_COLLECTION = 'Users'
export const USER_ROLES = ['Admin', 'Moderator', 'Manager', 'User']
export const ADMIN_PANEL_ROLES = ['Admin', 'Moderator', 'Manager']
export const DEFAULT_USER_ROLE = 'User'

function normalizeUser(user) {
  return {
    ...user,
    name: typeof user.name === 'string' ? user.name.trim() : ''
  }
}

function assertRequiredUserName(name) {
  if (!name || !name.trim()) {
    throw new Error('User name is required.')
  }
}

export async function fetchUsers() {
  const usersQuery = query(collection(firestore, USERS_COLLECTION), orderBy('createdAt', 'desc'))
  const snapshot = await getDocs(usersQuery)
  return snapshot.docs.map(item => normalizeUser({
    uid: item.id,
    ...item.data()
  }))
}

export async function fetchUser(uid) {
  const snapshot = await getDoc(doc(firestore, USERS_COLLECTION, uid))
  if (!snapshot.exists()) return null
  return normalizeUser({
    uid: snapshot.id,
    ...snapshot.data()
  })
}

// Профиль самостоятельно зарегистрированного пользователя. Роль всегда `User`:
// доступ в админку выдает администратор вручную через раздел «Пользователи».
export async function createUserProfile({ uid, email, name }) {
  assertRequiredUserName(name)
  const userRef = doc(firestore, USERS_COLLECTION, uid)

  try {
    const existing = await getDoc(userRef)
    if (existing.exists()) {
      // Документ уже есть (повторный вызов для того же uid) — ничего не перезаписываем.
      return normalizeUser({ uid, ...existing.data() })
    }
  } catch (error) {
    // Правила могут запрещать чтение чужих документов. uid только что выдан
    // Firebase Auth, поэтому документа для него быть не может: создаем.
  }

  const profile = {
    uid,
    name: name.trim(),
    email: email || '',
    role: DEFAULT_USER_ROLE,
    image: '',
    isBlocked: false,
    createdAt: new Date().toISOString()
  }

  await setDoc(userRef, {
    ...profile,
    updatedAt: serverTimestamp()
  })

  return normalizeUser(profile)
}

export async function saveUser(user) {
  const uid = user.uid
  assertRequiredUserName(user.name)
  await setDoc(doc(firestore, USERS_COLLECTION, uid), {
    uid,
    name: user.name.trim(),
    email: user.email || '',
    role: user.role || 'User',
    image: user.image || '',
    isBlocked: Boolean(user.isBlocked),
    createdAt: user.createdAt || new Date().toISOString(),
    updatedAt: serverTimestamp()
  }, { merge: true })
}

export async function updateUserAccess(uid, patch) {
  const normalizedPatch = { ...patch }
  if (Object.prototype.hasOwnProperty.call(normalizedPatch, 'name')) {
    assertRequiredUserName(normalizedPatch.name)
    normalizedPatch.name = normalizedPatch.name.trim()
  }

  await updateDoc(doc(firestore, USERS_COLLECTION, uid), {
    ...normalizedPatch,
    updatedAt: serverTimestamp()
  })
}
